<<template>
	<div class="flex">
		<img class="pointer" @click="goBack" src="../assets/icon/back.png"
			style="width: 13px;height: 13px;margin-right: 6px;" alt="" />
		<el-breadcrumb separator="/">
			<el-breadcrumb-item v-for="(item,index) in pathList" :replace='true'
				:to="index<pathList.length-1? { path: item.path }:{}"><span
					:class="index==pathList.length-1?'blodFont':''">{{item.title}}</span></el-breadcrumb-item>
		</el-breadcrumb>
	</div>
	</template>

	<script>
		export default {
			props: {
				pathList: {
					type: Array,
					default: []
				}
			},
			data() {
				return {

				}
			},
			methods: {
				goBack() {
					this.$router.go(-1)
				}
			}
		}
	</script>

	<style lang="less" scoped>
		::v-deep .is-link {
			color: #999 !important;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
		}
		.blodFont {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 16px;
			color: #000000;
		}
	</style>